import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SessionContext } from "@/utility/useSession";
import { ReleaseFlag, useReleaseManagement } from "@/utility/feature-management";
import DashPage from "../dash/DashPage";
import NotFoundPage from "../error/NotFoundPage";
import ScanningInterface from "./components/ScanningInterface";

const ScanningPage = () => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const isScanningPageReleased = useReleaseManagement(ReleaseFlag.releaseScanningPage);

  if (session.current.site == null) {
    return null;
  }

  const prefs = session.current.site.preferences;
  if (!isScanningPageReleased || prefs.scanning_page_enabled !== true) {
    return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")} />;
  }

  // DD - RBAC checks to follow on a later date.
  // if (!hasAccess) {
  //   return (
  //     <DashPage>
  //       <AccessDeniedMessage />
  //     </DashPage>
  //   );
  // }

  return (
    <DashPage>
      <ScanningInterface />
    </DashPage>
  );
};

export default ScanningPage;
